import React from 'react';
import './App.scss';
import { SignInForm } from './sign_in_up/sign-in-form';
// import { firebaseApp } from './firebase/firebase';
import { FirebaseAuthProvider, IfFirebaseUnAuthed, IfFirebaseAuthedAnd } from '@react-firebase/auth';
import { FirestoreProvider } from '@react-firebase/firestore';
import { firebaseConfig } from './firebase/config';
import firebase, { User } from 'firebase/app';
import { NavTop } from './nav/nav-top';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Riders } from './riders-and-bikes/riders';
import { NewRider } from './riders-and-bikes/new-rider';
import { EditRider } from './riders-and-bikes/edit-rider';
import { Container } from 'bloomer/lib/layout/Container';
import { NewBike } from './riders-and-bikes/new-bike';
import { EditBike } from './riders-and-bikes/edit-bike';
import { Reports } from './riders-and-bikes/reports';
import { Footer, Content, Columns, Column, Icon } from 'bloomer';

export function App() {
  return (
    <Router>
      <FirebaseAuthProvider {...firebaseConfig} firebase={firebase}>
        <FirestoreProvider {...firebaseConfig} firebase={firebase}>
          <IfFirebaseAuthedAnd
            filter={({ providerId, user }) => user.email && providerId !== 'anonymous'}
          >
            {({ user }: { user: User }) => (
              <div>
                <NavTop user={user}></NavTop>
                <Container style={{ marginBottom: '20px' }}>
                  <Switch>
                    <Route path="/bikes/new/:rider">
                      <NewBike user={user} />
                    </Route>
                    <Route path="/bikes/:id">
                      <EditBike user={user} />
                    </Route>
                    <Route path="/riders/new">
                      <NewRider user={user} />
                    </Route>
                    <Route path="/riders/:id">
                      <EditRider user={user} />
                    </Route>
                    <Route path="/riders">
                      <Riders user={user}></Riders>
                    </Route>
                    <Route path={'/'}>
                      <Reports user={user}></Reports>
                    </Route>
                  </Switch>
                </Container>
                {footer()}
              </div>
            )}
          </IfFirebaseAuthedAnd>
          <IfFirebaseUnAuthed>{() => <SignInForm></SignInForm>}</IfFirebaseUnAuthed>
        </FirestoreProvider>
      </FirebaseAuthProvider>
    </Router>
  );
}

function footer() {
  return (
    <Footer style={{ marginTop: '50px' }}>
      <Container>
        <Content isSize="small" hasTextAlign="centered">
          <p>
            <a href="/privacy_policy" target="_blank" style={{ color: '#555' }}>
              Privacy Policy
            </a>{' '}
          </p>
          <p>
            <a href="/terms_and_conditions" target="_blank" style={{ color: '#555' }}>
              Terms &amp; Conditions
            </a>
          </p>
        </Content>
      </Container>
    </Footer>
  );
}
